import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";

const CorporateHero = () => {
  const scrollToServices = () => {
    const el = document.getElementById("services");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToContact = () => {
    const el = document.getElementById("contact-form");
    if (el) {
      const yOffset = -100;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="min-h-[80vh] flex items-center pt-24 pb-16 px-4">
      <div className="container mx-auto max-w-5xl text-center">
        <div className="space-y-6 animate-fade-in-up">
          <div className="inline-block bg-primary/10 border border-primary/20 px-4 py-2 rounded-full mb-2">
            <span className="text-primary font-semibold text-sm">🚀 פתרונות דיגיטליים מתקדמים</span>
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
            נבנה לך את{" "}
            <span className="text-gradient">הנוכחות הדיגיטלית</span>
            <br />
            שהעסק שלך צריך
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-foreground/70 max-w-3xl mx-auto leading-relaxed">
            אתרים, חנויות איקומרס, אינטגרציות שופיפיי, ממשקים מותאמים ואוטומציות שיווקיות – הכל תחת קורת גג אחת
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button
              onClick={scrollToServices}
              size="lg"
              className="glow-primary text-lg sm:text-xl px-8 sm:px-12 py-6 sm:py-8">

              גלו את השירותים שלנו
              <ArrowDown className="w-5 h-5 mr-2" />
            </Button>
            <Button
              onClick={scrollToContact}
              variant="outline"
              size="lg"
              className="text-lg sm:text-xl px-8 sm:px-12 py-6 sm:py-8">

              צרו קשר
            </Button>
          </div>
        </div>
      </div>
    </section>);

};

export default CorporateHero;